@switch (variant) {
  @case ('flat') {
    <button mat-flat-button [disabled]="disabled" [class]="customClasses" [color]="color">
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>
  }
  @case ('stroked') {
    <button mat-stroked-button [disabled]="disabled" [class]="customClasses" [color]="color">
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>
  }
  @case ('raised') {
    <button mat-raised-button [disabled]="disabled" [class]="customClasses" [color]="color">
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>
  }
  @default {
    <button mat-button [disabled]="disabled" [class]="customClasses" [color]="color">
      <ng-container *ngTemplateOutlet="buttonContent"></ng-container>
    </button>
  }
}

<ng-template #buttonContent>
  <span class="tw-flex tw-items-center tw-justify-center tw-gap-2">
    <ng-content></ng-content>
  </span>
</ng-template>